@if (signal) {
  <div class="form-row align-items-center">
    <div class="col-auto">
      @if (showColorPicker) {
        <scitis-color-picker [displayLabel]="false" [displayInput]="false"
          (selectedColor)="onSelectedColor($event)"
        [signalColor]="interactiveDataAnalysisProperty.color"></scitis-color-picker>
      }
    </div>
    <div class="col">
      <strong class="d-block">
        <span [innerText]="signal.displayedText | translate" [ngClass]="signalClass"></span>
        @if (signal.machineSignal) {
          <span class="fa-solid fa-gear ml-1" [title]="'Configured machine signal' | translate"
          ></span>
        }
      </strong>
      <span class="text-muted small d-block" [innerHTML]="signal.table"></span>
    </div>
    <div class="col-auto">
      <div class="custom-control custom-switch d-inline-flex">
        <input type="checkbox" class="custom-control-input" [id]="'custom_range_'+signal.id"
          [(ngModel)]="interactiveDataAnalysisProperty.customRange">
          <label class="custom-control-label" [for]="'custom_range_'+signal.id" translate>Custom y-axis</label>
        </div>
        <span class="fa-solid fa-arrow-{{axisPosition}} text-muted ml-3" placement="top" [ngbTooltip]="getPositionTooltip()"></span>
      </div>
    </div>
  }
  <!-- Only show when switch is active -->
  <div [ngClass]="customAxisClass">
    <div class="divider"></div>
    <div class="row">
      <div class="col">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" translate>Min.</span>
          </div>
          <input type="number" [(ngModel)]="interactiveDataAnalysisProperty.minY" class="form-control" placeholder="0">
        </div>
      </div>
      <div class="col">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" translate>Max.</span>
          </div>
          <input type="number" [(ngModel)]="interactiveDataAnalysisProperty.maxY" class="form-control" placeholder="0">
        </div>
      </div>
    </div>
  </div>
